export const SUMMARY_TITLE = 'Summary';
export const SUMMARY_CONTENT = `The Summary widget gives you an overview of your policies in action. You see the total number
      of distribution policies, the total number of requests that were matched against your
      distribution policies, and the number and percentage of requests that were served by each of
      your CDNs.`;

export const POLICY_TITLE = 'All Policies';
export const POLICY_CONTENT = `The All Policies widget shows you a list of your distribution policies. For each policy,
      you see the policy name, its ranking (index), the number of requests that were matched to each policy,
      and the date when the policy was last updated. Click on a policy name to drill down to see more information about the policy.
`;

export const DETAIL_TITLE = 'Policy Details';
export const DETAIL_CONTENT =
  'The Policy Details widget shows the name, ranking, and filter used for the selected policy. You can choose another policy from the list about this widget. The policy with the highest index takes precedence over all lower-ranked policies.';

export const REQUEST_TITLE = 'Requests';
export const REQUEST_CONTENT =
  'The Requests widget shows the number of requests matched to this policy during each interval in the selected time range.';

export const ASSIGNMENT_TITLE = 'Request Assignment';
export const ASSIGNMENT_CONTENT =
  'The Request Assignment widget shows you the percentage of allocated and actual traffic for each CDN included in the policy.';
